import { Rendition, SpineItem } from '../types/epub';

function getItem(renditions: ReadonlyArray<Rendition>, path: string): SpineItem {
  for (const { itemIndices } of renditions) {
    if (path in itemIndices) {
      return itemIndices[path];
    }
  }
  throw new Error(`${path} is not found in the package document.`);
}

export function getTitle(renditions: ReadonlyArray<Rendition>, path: string) {
  return getItem(renditions, path).title;
}

export function getFaviconPath(
  renditions: ReadonlyArray<Rendition>,
  path: string,
  basePath: string = '/',
) {
  const favicon = getItem(renditions, path).favicon;
  if (!favicon) {
    return null;
  }
  return `${basePath.replace(/\/+$/, '')}/${favicon}`;
}
